//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
import allTopics from '~/components/subject/alltopics';
import hotTheme from '~/components/subject/hot-subject';
import pagination from '~/components/public/component-pagination';
import * as types from '~/types';
import * as api from '~/api/index';
import AdListItemMixins from '~/mixins/ad-list-item';
export default {
  components: {
    allTopics,
    hotTheme,
    pagination,
  },
  mixins: [AdListItemMixins],
  async asyncData({ error, $axios }) {
    try {
      // 当热门主题小于五条时,需要获取我关注的热门主题,获取不到userID,,登录成功,客户端会监听登录状态
      const [allThemeData, hotThemeDataResult, fillData] = await Promise.all([
        $axios(
          api.allTheme({
            page: 1,
            limit: 15,
          })
        ),
        $axios(
          api.hotTheme({
            page: 1,
          })
        ),
        $axios(
          api.getMyFocus({
            id: -1,
            page: 1,
            isHot: true,
            limit: 15,
          })
        ),
      ]);

      const total = allThemeData.totalCount;
      let hotThemeData = [];

      if (
        hotThemeDataResult &&
        hotThemeDataResult.result &&
        hotThemeDataResult.result.length > 0
      ) {
        if (hotThemeDataResult.result && hotThemeDataResult.result.length < 5) {
          const length = 5 - hotThemeDataResult.result.length;
          const focusItem =
            fillData && fillData.result ? fillData.result.slice(0, length) : [];
          hotThemeData = [...hotThemeDataResult.result, ...focusItem];
        } else if (
          hotThemeDataResult.result &&
          hotThemeDataResult.result.length >= 5
        ) {
          hotThemeData = hotThemeDataResult.result.slice(0, 5);
        } else {
          hotThemeData =
            fillData && fillData.result ? fillData.result.slice(0, 5) : [];
        }
      }

      return {
        listData: allThemeData.result ? allThemeData.result : [],
        total,
        hotThemeData,
      };
    } catch (err) {
      error({
        statusCode: 404,
        message: '文章不存在',
      });
    }
  },
  data() {
    return {
      focus: 'allTopics',
      content: '',
      total: 0,
      currentPage: 1,
      // listData: []
    };
  },
  head() {
    return {
      title: '格隆汇主题-及时分析市场热点主题',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            '格隆汇主题栏目对社会各个行业及热点话题进行了专业角度的分析,以便大家对这些信息有更好的了解和认知,欢迎大家访问格隆汇官网.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: '货币交易走势,创业板公司涨跌',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.gelonghui.com/subject',
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: `https://m.gelonghui.com/subject/`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'userId']),
    subjectListWithAd() {
      // 插入广告
      const test = this.insertAdToData(
        this.listData,
        this.subjectList_ad,
        4,
        9
      );
      return test;
    },
  },
  methods: {
    ...mapMutations('user', [types.SHOW_LOGIN_FORM]),
    async selectSubject() {
      if (!this.content) {
        this.currentPage = 1;
        this.getAllSubjectData();
        return;
      }
      this.currentPage = 1;
      const res = await this.$axios(
        api.selectSubject({
          keyword: this.content,
          page: 1,
          count: 15,
        })
      );
      this.total = res.totalCount;
      const idList = [];
      res.result.forEach(e => {
        e.name = e.name.replace(/<hl>/g, '').replace(/<\/hl>/g, '');
        idList.push(e.subjectId);
      });
      const statusRes = await this.$axios(
        api.getSubjectFollowStatus({
          idList,
        })
      );
      res.result.forEach(e => {
        e.isFollow = statusRes.result[e.subjectId];
      });
      switch (this.focus) {
        case 'myAttention':
          this.listData = res.result;
          // this.

          break;
        case 'allTopics':
          this.listData = res.result;
          break;
      }
    },
    changeTag(type) {
      if (type === 'myAttention' && !this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      this.focus = type;
      this.currentPage = 1;
      switch (this.focus) {
        case 'myAttention':
          this.getMyAttentionData();
          break;
        case 'allTopics':
          this.getAllSubjectData();
          break;
      }
    },
    pageChange(v) {
      this.currentPage = v;
      switch (this.focus) {
        case 'myAttention':
          this.getMyAttentionData();
          break;
        case 'allTopics':
          this.getAllSubjectData();
          break;
      }
    },
    async getMyAttentionData() {
      const res = await this.$axios(
        api.getMyFocus({
          id: this.userId,
          page: this.currentPage,
          isHot: false,
          limit: 15, // 后端默认15条
        })
      );
      this.total = res.totalCount;
      this.listData = res && res.result ? res.result : [];
    },
    async getAllSubjectData() {
      const res = await this.$axios(
        api.allTheme({
          page: this.currentPage,
          limit: 15, // 后端默认15条
        })
      );
      this.total = res.totalCount;
      this.listData = res && res.result ? res.result : [];
    },
    async getHotSubject() {
      const hotThemeData = await this.$axios(
        api.hotTheme({
          page: 1,
        })
      );
      let fillData = null;
      if (this.userId) {
        fillData = await this.$axios(
          api.getMyFocus({
            id: this.userId,
            page: 1,
            limit: 15,
            isHot: true,
          })
        );
      }

      if (
        hotThemeData &&
        hotThemeData.result &&
        hotThemeData.result.length > 0
      ) {
        if (hotThemeData.result && hotThemeData.result.length < 5) {
          const length = 5 - hotThemeData.result.length;
          const focusItem = fillData.result.slice(0, length);
          this.hotThemeData = [...hotThemeData.result, ...focusItem];
        } else if (hotThemeData.result && hotThemeData.result.length >= 5) {
          this.hotThemeData = hotThemeData.result.slice(0, 5);
        } else {
          this.hotThemeData =
            fillData && fillData.result ? fillData.result.slice(0, 5) : [];
        }
      } else {
        this.hotThemeData = [];
      }
    },
    refresh() {
      this.getHotSubject();
      if (!this.content) {
        switch (this.focus) {
          case 'allTopics':
            this.getAllSubjectData();
            break;
          case 'myAttention':
            this.getMyAttentionData();
            break;
        }
      } else {
        this.selectSubject();
      }
    },
  },
};
